import { createSlice } from "@reduxjs/toolkit";

// Initial state with more consistent types
const initialState = {
  currentUser: null, // Use null when no user is logged in
  isLoading: false,
  error: null, // Store actual error messages
};

// Create the slice for managing user state
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.error = null; // Clear any previous errors when loading starts
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload; // Store the actual error message
    },

    // GET USER SUCCESS
    getUserSuccess(state, action) {
      state.isLoading = false;
      state.currentUser = action.payload;
      state.error = null; // Clear any previous error if successful
    },

    // LOGOUT SUCCESS
    logoutSuccess(state) {
      state.currentUser = null; // Set the user to null when logging out
      state.error = null;
    },
  },
});

// Action creators are generated for each reducer
export const { startLoading, hasError, getUserSuccess, logoutSuccess } = userSlice.actions;

// Async thunk to get the current user from localStorage
export const getUser = () => async (dispatch) => {
  try {
    dispatch(startLoading());

    const token = localStorage.getItem("user");
    const user = token ? JSON.parse(token) : null; // Safely parse and handle null

    if (!user) {
      // Handle the case where no user is found
      dispatch(hasError("User is not authorized or not found."));
      return null;
    }

    // Dispatch the user success action if user exists
    dispatch(getUserSuccess(user));
    return user;
  } catch (error) {
    // Catch and dispatch error with a meaningful message
    dispatch(hasError("Failed to fetch user data."));
  }
};

// Async thunk to log out the user by clearing localStorage
export const logout = () => async (dispatch) => {
  try {
    localStorage.removeItem("user");
    dispatch(logoutSuccess()); // Dispatch logout success action
  } catch (error) {
    // Dispatch an error if something goes wrong
    dispatch(hasError("Failed to log out."));
  }
};

export default userSlice.reducer;
